import { CALL_API } from '../login/api.middleware';
import { AFFILIATE_SERVICE_URL } from '../constants/api';
import * as type from '../constants/ActionTypes';

export function postAppUser(formDetails) {

  const body = {
    username: formDetails.username,
    password: formDetails.password,
  };

  let config = {
    method: 'POST',
    body: JSON.stringify(body)
  };

  return {
    [CALL_API]: {
      endpoint: `${AFFILIATE_SERVICE_URL}/affiliates/user`,
      types: [
        type.APP_USER_POST_REQUEST,
        type.APP_USER_POST_SUCCESS,
        type.APP_USER_POST_FAILURE
      ],
      config,
      authenticated: true
    }
  };
}
